//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
//@end

//@import components
import RelatedCourseModuleSkeleton from 'app_components/modules/academic/relatedcourses/components/relatedCourseModuleSkeleton';
import OfferdCardCommon from 'app_components/commons/offercard'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../relatedcoursesModule.scss'

// @ADD Component types
interface IRelatedcoursesModuleLayoutProps {
	loading: boolean
	type: string
}

const RelatedcoursesModuleLayout: React.FC<IRelatedcoursesModuleLayoutProps> = (props) => {

  const { t } = useTranslation()
  const { type } = props

  return(
    <div className={'related-courses'}>
    	<Container fluid>
			  <Row>
			    <Col xs={12} md={8}>
			    	<div className={'Atomtextodesplegable'}>
			    		<span className={'titulo'}>CURSOS RELACIONADOS</span>
			    	</div>
			    </Col>
			  </Row>
			  <Row>
			    <Col xs={12} md={8}>
			    	{props.loading ? (
			        <RelatedCourseModuleSkeleton />
			      ) : (
			        <div className={'content-related-courses'}>
			          <OfferdCardCommon offer={[]}/>
			          <OfferdCardCommon offer={[]}/>
			      	</div>
			      )}
			    </Col>
			  </Row>
			  <Row>
			    <Col xs={12} md={8} style={{display:'flex', gap:'40px', flexDirection:'row', justifyContent:'center'}}>
			    	{ type === 'mooc' ? (
			    		<div className={'Atomtextodesplegable'}>
				    		<button className={'button-plus'}>Sobre los MOOC</button>
				    	</div>
			    		): null
			      }
			    	<div className={'Atomtextodesplegable'}>
			    		<button className={'button-plus'}>Ver todos</button>
			    	</div>
			    </Col>
			  </Row>
			</Container>
    </div>
  )
}

export default RelatedcoursesModuleLayout
